import React from 'react';

import { SVGPropsType } from 'src/types';

const Download = (props: SVGPropsType) => {
    const { fill, stroke, onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            onClick={onClick}
            style={style}
            className={className}
        >
            <g clipPath="url(#clip0_33922_19678)">
                <circle cx="16.5" cy="16" r="16" fill={fill} />
                <path
                    d="M24.6 17.8C24.06 17.8 23.7 18.16 23.7 18.7V22.3C23.7 22.57 23.61 22.75 23.43 22.93C23.25 23.11 23.07 23.2 22.8 23.2H10.2C9.93 23.2 9.75 23.11 9.57 22.93C9.39 22.75 9.3 22.57 9.3 22.3V18.7C9.3 18.16 8.94 17.8 8.4 17.8C7.86 17.8 7.5 18.16 7.5 18.7V22.3C7.5 23.02 7.77 23.74 8.31 24.19C8.76 24.73 9.48 25 10.2 25H22.8C23.52 25 24.24 24.73 24.69 24.19C25.14 23.65 25.5 23.02 25.5 22.3V18.7C25.5 18.25 25.14 17.8 24.6 17.8Z"
                    fill={stroke}
                />
                <path
                    d="M15.8696 19.33C15.9596 19.42 16.0496 19.51 16.1396 19.51C16.2296 19.6 16.4096 19.6 16.4996 19.6C16.5896 19.6 16.7696 19.6 16.8596 19.51C16.9496 19.42 17.0396 19.42 17.1296 19.33L21.6296 14.83C21.9896 14.47 21.9896 13.93 21.6296 13.57C21.2696 13.21 20.7296 13.21 20.3696 13.57L17.3996 16.54V7.90003C17.3996 7.36003 17.0396 7.00003 16.4996 7.00003C15.9596 7.00003 15.5996 7.36003 15.5996 7.90003V16.54L12.6296 13.57C12.2696 13.21 11.7296 13.21 11.3696 13.57C11.0096 13.93 11.0096 14.47 11.3696 14.83L15.8696 19.33Z"
                    fill={stroke}
                />
            </g>
            <defs>
                <clipPath id="clip0_33922_19678">
                    <rect width="32" height="32" fill={stroke} transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Download;
